import { render } from "./AnthropicForm.vue?vue&type=template&id=3da256eb&ts=true"
import script from "./AnthropicForm.vue?vue&type=script&lang=ts"
export * from "./AnthropicForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__